<div class="filter-chips-container">
  <div *ngFor="let option of options; let i = index">
    <div
      class="filter-chips"
      [ngClass]="{
        'filter-chips-container-unselected': option.disabled,
        'filter-chips-container-selected': !option.disabled,
      }"
      (click)="onClickEvent(i)"
    >
      <div>
        {{ (option.id | beautifyDisplayString) + ' (' + option.numOfItems + ')' }}
      </div>
    </div>
  </div>
</div>
